// eslint-disable-next-line jsdoc/require-jsdoc
export default async function Header(loadLanguage = false) {
    if (loadLanguage) {
        const { loadDefaultLanguage } = await import('@v4/locale/async');
        await loadDefaultLanguage();
    }

    const register = (await import('@v4/common/directives')).default;
    const Vue = (await import('vue')).default;

    register(Vue);
    const { i18n } = await import('@v4/locale/async');
    const { navMenu } = await import('@v4/common/components/mixins/mixins');
    const gaEventHandler = (
        await import(
            /* webpackChunkName: "gaEventHandler", webpackPreload: true */ '@v4/common/components/mixins/google-analytics'
        )
    ).default;
    const headerInstance = new Vue({
        el: '#header',
        // Adding the "name" property makes it easier for
        // the component to be found in Vue Dev Tools panel
        name: 'Header',
        components: {
            SearchBar: () => ({
                component: import(
                    /* webpackChunkName: "SearchBar-vue", webpackPreload: true */ '@v4/search/components/organisms/SearchBar'
                ),
            }),
            // @TODO(gevorg.makaryan@motork.io) DK-10836 Remove this module when the final decision will be made to delete the user menu
            // UserProfileMenu: () => ({
            //     component: import(
            //         /* webpackChunkName: "UserProfileMenu-vue", webpackPreload: true */ '@v4/common/components/organisms/UserProfileMenu'
            //     ),
            // }),
            DkButton: () => ({
                component: import(
                    /* webpackChunkName: "DkButton-vue", webpackPreload: true */ '@v4/common/components/atoms/DkButton.vue'
                ),
            }),
        },
        i18n,
        mixins: [navMenu, gaEventHandler],
        methods: {
            onSearchBarToggle() {
                this.toggleSearchBar();
            },
            trackEvMenuItemClick(classes) {
                if (classes && classes.includes('ev-page')) {
                    this.pushGaEvent('EV page', 'EV link click', 'Click on EV menu');
                }
            },
        },
    });

    return headerInstance;
}
